import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
export class SentryReactInitializer {
    constructor(integrations = []) {
        this.integrations = integrations;
        this.tags = {};
    }
    initialize(options, user, tags) {
        var _a, _b;
        const initialScope = {
            tags: Object.assign(Object.assign({}, tags), (_a = options === null || options === void 0 ? void 0 : options.initialScope) === null || _a === void 0 ? void 0 : _a.tags),
            user: Object.assign(Object.assign({}, user.toJSON()), (_b = options === null || options === void 0 ? void 0 : options.initialScope) === null || _b === void 0 ? void 0 : _b.user),
        };
        Sentry.init(Object.assign(Object.assign({ integrations: [new Integrations.BrowserTracing(), ...this.integrations] }, options), { initialScope }));
    }
    addTags(key, value) {
        this.tags[key] = value;
    }
}
//# sourceMappingURL=SentryReactInitializer.js.map